import { ProjectStatus } from '../interfaces';
import JobHistory from '../JobHistory';

export default function AdminAddManualShipment() {
  return (
    <JobHistory
      statusesFilter={
        (statusOption: any) =>
          [ProjectStatus.CREATED, ProjectStatus.IN_PROGRESS]
            .includes(statusOption?.value)
      }
      isAdmin
      isAddShipment
    />
  );
}
